<div class="sh-file-input-container box-border" data-testid="details-attachments-container">
    <!-- Hidden file input -->
    <input
        #fileInput
        data-testid="global-attachments-input-file"
        type="file"
        [accept]="acceptedFileTypes()"
        [multiple]="multiple()"
        [disabled]="isDisabledInternal()"
        (change)="onFileSelected($event)"
        style="display: none"
    />

    <!-- Drag and drop area (shown when no files at all) -->
    @if (files.length === 0 && serverFiles().length === 0) {
        <sh-empty-state
            drag-and-drop
            icon="upload"
            [header]="'common.file-upload.drag-files-here' | translate"
            [label]="'common.file-upload.file-character-limit' | translate"
            [class.drag-over]="isDragOver"
            (drop)="onDrop($event)"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            class="h-[250px] m-0 bg-shui-base-3 border border-dashed border-shui-base-5 rounded-md"
        >
            <sh-button
                slot="footer"
                size="max-content"
                color="tertiary"
                [label]="'common.file-upload.choose-file' | translate"
                [disabled]="isDisabledInternal()"
                (click)="fileInput.click()"
            ></sh-button>
        </sh-empty-state>
    }

    <!-- File list table (shown when files exist) -->
    @if (files.length > 0 || serverFiles().length > 0) {
        <div class="file-list-container">
            <sh-table fit-content style="height: fit-content; border-top: 1px solid var(--text-disabled)">
                <!-- Server-side (already uploaded) files -->
                @for (s3File of serverFiles(); track s3File.Key) {
                    <sh-table-row data-testid="details-attachments-container-file">
                        <sh-table-cell columns="20">
                            <sh-text size="body-1" color="primary" style="line-height: 32px">
                                {{ getServerFileName(s3File.Key) }}
                            </sh-text>
                        </sh-table-cell>
                        <sh-table-cell columns="4">
                            <div class="flex gap-3 justify-end items-center h-[32px]">
                                <sh-icon
                                    button
                                    icon="download"
                                    size="s"
                                    [title]="'common.download' | translate"
                                    (click)="onDownloadServerFile($event, s3File.Key)"
                                ></sh-icon>
                                @if (!isDisabledInternal()) {
                                    <sh-icon
                                        button
                                        icon="delete"
                                        size="s"
                                        [title]="'common.remove' | translate"
                                        (click)="onDeleteServerFile($event, s3File.Key)"
                                    ></sh-icon>
                                }
                            </div>
                        </sh-table-cell>
                    </sh-table-row>
                }

                <!-- Locally selected (pending upload) files -->
                @for (fileItem of files; track $index; let i = $index) {
                    <sh-table-row [attr.data-testid]="'global-attachments-container-' + fileItem.file.name">
                        <!-- File name -->
                        <sh-table-cell [columns]="fileItem.errorMessage ? '10' : '20'">
                            <sh-text
                                [size]="'body-1'"
                                [color]="fileItem.status === 'pending' ? 'secondary' : 'primary'"
                                style="line-height: 32px"
                            >
                                {{ fileItem.file.name }}
                            </sh-text>
                        </sh-table-cell>

                        <!-- Error message (if any) -->
                        @if (fileItem.errorMessage) {
                            <sh-table-cell columns="10">
                                <sh-text size="body-1" style="line-height: 32px">
                                    {{ fileItem.errorMessage | translate }}
                                </sh-text>
                            </sh-table-cell>
                        }

                        <!-- Remove button -->
                        <sh-table-cell columns="4">
                            <div class="flex gap-3 justify-end items-center h-[32px]">
                                <sh-icon
                                    button
                                    icon="cancel"
                                    size="s"
                                    [class.disabled]="isDisabledInternal()"
                                    (click)="onRemoveClick($event, i)"
                                >
                                </sh-icon>
                            </div>
                        </sh-table-cell>
                    </sh-table-row>
                }
            </sh-table>

            <!-- Browse button below table -->
            @if (multiple() && !isDisabledInternal()) {
                <div class="browse-button-container mt-2">
                    <sh-button
                        size="max-content"
                        [label]="'common.file-upload.choose-file' | translate"
                        [disabled]="isDisabledInternal()"
                        (click)="fileInput.click()"
                    ></sh-button>
                </div>
            }
        </div>
    }
</div>
